/* eslint-disable no-lone-blocks */
export function Reducer(state, { type, payload }) {
  switch (type) {
    case "":{
      
    }
    

    default:
      return state;
  }
}
